import React from "react";
import "./SimpleInput.css";
function SimpleInput(props) {
  const {
    onChange,
    inputValue,
    placeholder,
    name,
    id,
    errorMsg = "Only numeric values are allowed",
    flag = false,
    maxLength = "12",
    containerStyle,
    disabled = false,
    type = "text",
    showLength = false,
    label='Search'
  } = props;
  // console.log('simpleValue:', inputValue)

  return (
    <div>
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid black"
        }}
      >
        <label
          htmlFor="si_input"
          style={{ margin: "0px 5px", fontSize: "12px" }}
        >
          $
        </label> */}
      <input
        id={id}
        className="si_input"
        id="si_input"
        type={type}
        name={name}
        label={label}
        value={inputValue}
        placeholder={placeholder}
        onChange={onChange}
        maxLength={maxLength}
        style={containerStyle}
        disabled={disabled}
      />
      {maxLength && showLength ? (
        <p
          className="ltai_label"
          style={{
            textAlign: "right",
            width: "100px",
            float: "right",
          }}
        >
          {inputValue.length} / {maxLength}
        </p>
      ) : null}
      <p className="si_error_text" style={{ display: flag ? "block" : "none" }}>
        {errorMsg}
      </p>
    </div>
  );
}

export default SimpleInput;
